const DG_PDP_STATE = '__dgPdpInitialized';

if (!window[DG_PDP_STATE]) {
  window[DG_PDP_STATE] = true;

  const TYPE_KEYS = {
    't-shirt': 'tshirt',
    shirt: 'tshirt',
    tshirt: 'tshirt',
    tee: 'tshirt',
    sweatshirt: 'sweatshirt',
    hoodie: 'hoodie',
  };
  const TYPE_DISPLAY_NAMES = {
    tshirt: 'T-shirt',
    sweatshirt: 'Sweatshirt',
    hoodie: 'Hoodie',
  };

  const COLOR_ALIASES = {
    black: { all: 'black' },
    white: { all: 'white' },
    'dark grey': { all: 'dark_grey' },
    'dark gray': { all: 'dark_grey' },
    grey: { all: 'grey' },
    gray: { all: 'grey' },
    beige: { all: 'beige' },
    mocha: { tshirt: 'mocha', sweatshirt: 'chocolate', hoodie: 'chocolate' },
    chocolate: { tshirt: 'mocha', sweatshirt: 'chocolate', hoodie: 'chocolate' },
    'dark blue': { tshirt: 'dark_blue', sweatshirt: 'navy_blue', hoodie: 'navy_blue' },
    navy: { tshirt: 'dark_blue', sweatshirt: 'navy_blue', hoodie: 'navy_blue' },
    'navy blue': { tshirt: 'dark_blue', sweatshirt: 'navy_blue', hoodie: 'navy_blue' },
    blue: { all: 'blue' },
    'light blue': { all: 'light_blue' },
    forest: { all: 'forest' },
    avocado: { all: 'forest' },
    'light green': { sweatshirt: 'light_green', hoodie: 'light_green' },
    bluestone: { tshirt: 'bluestone' },
    pink: { all: 'pink' },
    violet: { tshirt: 'violet', sweatshirt: 'purple', hoodie: 'purple' },
    purple: { tshirt: 'violet', sweatshirt: 'purple', hoodie: 'purple' },
    'light purple': { tshirt: 'violet', sweatshirt: 'purple', hoodie: 'purple' },
    red: { all: 'red' },
    claret: { all: 'claret' },
  };
  const DISPLAY_COLOR_NAMES = {
    tshirt: {
      grey: 'Gray',
      forest: 'Avocado',
      violet: 'Light Purple',
      dark_blue: 'Dark Blue',
    },
    sweatshirt: {
      grey: 'Grey',
      forest: 'Avocado',
      purple: 'Light Purple',
      navy_blue: 'Dark Blue',
    },
    hoodie: {
      grey: 'Grey',
      forest: 'Avocado',
      purple: 'Light Purple',
      navy_blue: 'Dark Blue',
    },
  };
  const SWATCH_LABEL_SELECTOR =
    '.product-information .variant-option--swatches[data-option-name="clothing-color"] .variant-option__button-label--has-swatch';
  const stripLegacyTypePrefix = (value) =>
    String(value || '')
      .normalize('NFKC')
      .replace(/\u2060/g, '')
      .replace(/^[tsh]-\s*/i, '')
      .trim();

  const normalizeText = (value) =>
    stripLegacyTypePrefix(value)
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  const normalizeVariantValue = (value) =>
    String(value || '')
      .normalize('NFKC')
      .replace(/\u2060/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  const optionValueEquals = (left, right) => normalizeVariantValue(left) === normalizeVariantValue(right);
  const isLegacyTypePrefixedValue = (value) => /^[tsh]-\s*/i.test(String(value || '').trim());

  const typeKeyFromValue = (value) => TYPE_KEYS[normalizeText(value)] || 'tshirt';

  const getProductInfoRoots = () =>
    Array.from(document.querySelectorAll('.product-information')).filter(
      (root) => root.querySelector('variant-picker') || root.querySelector('[data-dg-size-chart]')
    );

  const getPickerForRoot = (root) => {
    if (!root) return null;

    return root.querySelector('variant-picker[data-template-product-match="true"]') || root.querySelector('variant-picker');
  };

  const colorKeyFromValue = (value, typeKey) => {
    const alias = COLOR_ALIASES[normalizeText(value)];
    if (!alias) return null;

    return alias[typeKey] || alias.all || null;
  };

  const parseConfig = (picker) => {
    const script = picker.querySelector('script[data-dg-pdp-config]');
    if (!script?.textContent) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('DG PDP config could not be parsed', error);
      return null;
    }
  };

  const hasPartialVariantMatrix = (config) => Array.isArray(config?.variantMatrix) && config.variantMatrix.length >= 250;

  const getCurrentTypeKey = (root) => {
    const picker = getPickerForRoot(root);
    const input = picker?.querySelector('[data-option-name="type"] input:checked');
    return typeKeyFromValue(input?.value || 'T-shirt');
  };

  const isTouchPreviewMode = () =>
    window.matchMedia('(hover: none), (pointer: coarse)').matches;

  const ensurePopover = (label, imageUrl, colorName) => {
    if (label.dataset.dgPreviewImage !== imageUrl) {
      label.dataset.dgPreviewImage = imageUrl;
    }

    if (label.dataset.dgPreviewLabel !== colorName) {
      label.dataset.dgPreviewLabel = colorName;
    }
  };

  const setHiddenState = (element, hidden) => {
    if (element && element.hidden !== hidden) {
      element.hidden = hidden;
    }
  };

  const setDisplayState = (element, displayValue) => {
    if (element?.style && element.style.display !== displayValue) {
      element.style.display = displayValue;
    }
  };

  const setStylePropertyIfChanged = (element, property, value) => {
    if (!element?.style) return;

    if (element.style.getPropertyValue(property) !== value) {
      element.style.setProperty(property, value);
    }
  };

  const getSwatchPreview = () => {
    let preview = document.getElementById('dg-swatch-preview');

    if (!preview) {
      preview = document.createElement('div');
      preview.id = 'dg-swatch-preview';
      preview.setAttribute('aria-hidden', 'true');
      preview.innerHTML =
        '<img class="dg-swatch-preview__image" loading="eager" decoding="async" alt="">' +
        '<span class="dg-swatch-preview__label"></span>';
      document.body.appendChild(preview);
    }

    return preview;
  };

  const hideSwatchPreview = ({ force = false } = {}) => {
    const preview = document.getElementById('dg-swatch-preview');

    if (!force && preview?.dataset.persistent === 'true') return;

    document.querySelectorAll('.dg-swatch-is-hovering').forEach((label) => {
      label.classList.remove('dg-swatch-is-previewing');
      label.classList.remove('dg-swatch-is-hovering');
    });

    if (preview) {
      preview.classList.remove('is-visible');
      preview.style.opacity = '';
      preview.style.visibility = '';
      preview.style.left = '';
      preview.style.top = '';
      preview.style.transform = '';
      delete preview.dataset.persistent;
    }
  };

  const readableColorName = (typeKey, key) => {
    const override = DISPLAY_COLOR_NAMES[typeKey]?.[key];
    if (override) return override;

    return key
      .split('_')
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  };

  const readableTypeName = (value) => {
    const typeKey = typeKeyFromValue(value);
    return TYPE_DISPLAY_NAMES[typeKey] || String(value || '').trim() || 'T-shirt';
  };

  const clearTouchSwatchPreview = (root = document) => {
    if (!isTouchPreviewMode()) return;

    root.querySelectorAll?.('[data-option-name="clothing-color"]').forEach((fieldset) => {
      delete fieldset.dataset.dgMobilePreviewActive;
      fieldset.querySelectorAll('.dg-swatch-is-selected-preview, .dg-swatch-is-previewing, .dg-swatch-is-hovering').forEach((label) => {
        label.classList.remove('dg-swatch-is-selected-preview');
        label.classList.remove('dg-swatch-is-previewing');
        label.classList.remove('dg-swatch-is-hovering');
      });
    });

    hideSwatchPreview({ force: true });
  };

  const updateSwatchImage = (label, imageUrl, colorKey, typeKey) => {
    const swatch = label.querySelector('.swatch');
    const input = label.querySelector('input');
    const colorName = readableColorName(typeKey, colorKey);

    if (label.dataset.dgColorKey !== colorKey) {
      label.dataset.dgColorKey = colorKey;
    }

    setStylePropertyIfChanged(label, '--dg-color-order', '0');

    if (input && input.getAttribute('aria-label') !== colorName) {
      input.setAttribute('aria-label', colorName);
    }

    if (swatch) {
      setStylePropertyIfChanged(swatch, '--dg-reference-swatch', `url("${imageUrl}")`);

      if (!swatch.classList.contains('dg-reference-swatch')) {
        swatch.classList.add('dg-reference-swatch');
      }

      let image = swatch.querySelector('.dg-reference-swatch__image');

      if (!image) {
        image = document.createElement('img');
        image.className = 'dg-reference-swatch__image';
        image.loading = 'lazy';
        image.decoding = 'async';
        swatch.appendChild(image);
      }

      if (image.getAttribute('src') !== imageUrl) {
        image.src = imageUrl;
      }

      if (image.alt !== colorName) {
        image.alt = colorName;
      }
    }

    ensurePopover(label, imageUrl, colorName);
  };

  const showSwatchPreview = (label, { persistent = false } = {}) => {
    const imageUrl = label.dataset.dgPreviewImage;
    const colorName = label.dataset.dgPreviewLabel || '';

    if (label.dataset.dgSuppressPreview === 'true') return;

    document.querySelectorAll('.dg-swatch-is-hovering').forEach((item) => {
      if (item !== label) {
        item.classList.remove('dg-swatch-is-hovering');
        if (!item.classList.contains('dg-swatch-is-selected-preview')) {
          item.classList.remove('dg-swatch-is-previewing');
        }
      }
    });

    label.classList.add('dg-swatch-is-hovering');
    label.classList.add('dg-swatch-is-previewing');

    if (!imageUrl) return;

    const preview = getSwatchPreview();
    const image = preview.querySelector('.dg-swatch-preview__image');
    const text = preview.querySelector('.dg-swatch-preview__label');
    const rect = label.getBoundingClientRect();

    if (image) {
      image.src = imageUrl;
      image.alt = colorName;
    }

    if (text) {
      text.textContent = colorName;
    }

    preview.style.left = `${rect.left + rect.width / 2}px`;
    preview.style.top = `${rect.top - 10}px`;
    preview.style.transform = 'translate(-50%, -100%)';

    const previewRect = preview.getBoundingClientRect();
    const clampedLeft = Math.min(
      Math.max(rect.left + rect.width / 2, previewRect.width / 2 + 8),
      window.innerWidth - previewRect.width / 2 - 8
    );

    preview.style.left = `${clampedLeft}px`;

    if (previewRect.top < 8) {
      preview.style.top = `${rect.bottom + 10}px`;
      preview.style.transform = 'translate(-50%, 0)';
    }

    preview.dataset.persistent = persistent ? 'true' : 'false';

    window.requestAnimationFrame(() => {
      preview.classList.add('is-visible');
      preview.style.opacity = '1';
      preview.style.visibility = 'visible';
    });
  };

  const bindSwatchPreview = (label) => {
    if (label.dataset.dgSwatchPreviewBound === 'true') return;

    label.dataset.dgSwatchPreviewBound = 'true';

    const show = () => {
      if (isTouchPreviewMode()) return;

      showSwatchPreview(label);
    };

    const hide = () => {
      delete label.dataset.dgSuppressPreview;
      hideSwatchPreview();
    };

    label.addEventListener('pointerenter', show);
    label.addEventListener('mouseenter', show);
    label.addEventListener('focusin', show);
    label.addEventListener('pointerleave', hide);
    label.addEventListener('mouseleave', hide);
    label.addEventListener('focusout', hide);
    label.addEventListener('pointerup', hide);
    label.addEventListener('pointercancel', hide);
  };

  const upgradeLegacyColorButtonToSwatch = (fieldset, label) => {
    if (!fieldset || !label) return;

    fieldset.classList.add('variant-option--swatches');

    if (!label.classList.contains('variant-option__button-label--has-swatch')) {
      label.classList.add('variant-option__button-label--has-swatch');
    }

    let swatch = label.querySelector('.swatch');
    if (!swatch) {
      swatch = document.createElement('span');
      swatch.className = 'swatch swatch--unscaled swatch--unavailable';
      label.insertBefore(swatch, label.querySelector('.variant-option__strikethrough') || label.firstChild?.nextSibling || null);
    }

    label.querySelector('.variant-option__button-label__pill')?.remove();
    label.querySelector('.variant-option__button-label__text')?.remove();

    return swatch;
  };

  const syncSelectedSwatchPreview = (fieldset) => {
    if (!fieldset) return;

    fieldset.querySelectorAll('.dg-swatch-is-selected-preview').forEach((label) => {
      label.classList.remove('dg-swatch-is-selected-preview');
      label.classList.remove('dg-swatch-is-previewing');
    });

    if (!isTouchPreviewMode()) return;
    if (fieldset.dataset.dgMobilePreviewActive !== 'true') return;

    const checkedInput = fieldset.querySelector('input:checked');
    const checkedLabel = checkedInput?.closest('.variant-option__button-label');
    if (!checkedLabel || checkedLabel.hidden || checkedLabel.style.display === 'none') return;

    checkedLabel.classList.add('dg-swatch-is-selected-preview');
    checkedLabel.classList.add('dg-swatch-is-previewing');
    showSwatchPreview(checkedLabel, { persistent: true });
  };

  const applyInputSelection = (input, { activateMobilePreview = false } = {}) => {
    if (!(input instanceof HTMLInputElement)) return;

    const fieldset = input.closest('fieldset, [data-option-name]');
    const wasChecked = input.checked;

    document.querySelectorAll(`input[name="${CSS.escape(input.name)}"]`).forEach((radio) => {
      radio.dataset.currentChecked = radio === input ? 'true' : 'false';
      radio.checked = radio === input;
    });

    input.checked = true;
    input.dataset.currentChecked = 'true';

    if (fieldset && isTouchPreviewMode()) {
      if (activateMobilePreview) {
        fieldset.dataset.dgMobilePreviewActive = 'true';
      } else {
        delete fieldset.dataset.dgMobilePreviewActive;
      }
    }

    if (wasChecked) {
      syncSelectedSwatchPreview(fieldset);
      return;
    }

    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    syncSelectedSwatchPreview(fieldset);
  };

  const selectSwatchLabel = (label) => {
    const input = label.querySelector('input');
    const fieldset = label.closest('[data-option-name="clothing-color"]');

    if (!input || input.getAttribute('aria-disabled') === 'true' || input.dataset.optionAvailable === 'false') return;

    applyInputSelection(input, { activateMobilePreview: true });
    label.dataset.dgSuppressPreview = 'true';
    hideSwatchPreview({ force: true });
    syncSelectedSwatchPreview(fieldset);
    scheduleSync();
  };

  const swatchLabelFromPoint = (clientX, clientY) =>
    Array.from(document.querySelectorAll(SWATCH_LABEL_SELECTOR)).find((label) => {
      if (label.hidden || getComputedStyle(label).display === 'none') return false;

      const rect = label.getBoundingClientRect();

      return clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
    });

  const isOptionAvailable = (label) => {
    const input = label.querySelector('input');
    if (!input) return false;

    return input.getAttribute('aria-disabled') !== 'true' && input.dataset.optionAvailable !== 'false';
  };

  const setLabelAvailability = (label, isAvailable) => {
    const input = label?.querySelector('input');
    if (!(input instanceof HTMLInputElement)) return false;

    const nextAvailable = Boolean(isAvailable);
    const optionUnavailable = nextAvailable ? 'false' : 'true';
    const optionAvailable = nextAvailable ? 'true' : 'false';

    if (label.dataset.dgOptionUnavailable !== optionUnavailable) {
      label.dataset.dgOptionUnavailable = optionUnavailable;
    }

    if (input.dataset.optionAvailable !== optionAvailable) {
      input.dataset.optionAvailable = optionAvailable;
    }

    if (input.disabled !== !nextAvailable) {
      input.disabled = !nextAvailable;
    }

    if (nextAvailable) {
      if (input.getAttribute('aria-disabled') === 'true') {
        input.removeAttribute('aria-disabled');
      }
    } else {
      if (input.getAttribute('aria-disabled') !== 'true') {
        input.setAttribute('aria-disabled', 'true');
      }
    }

    return nextAvailable;
  };

  const prefixScore = (value, typeKey) => {
    const rawValue = String(value || '').trim();

    if (/^H-/i.test(rawValue)) return typeKey === 'hoodie' ? 8 : 0;
    if (/^S-/i.test(rawValue)) return typeKey === 'sweatshirt' ? 7 : typeKey === 'hoodie' ? 1 : 0;
    if (/^T-/i.test(rawValue)) return typeKey === 'tshirt' ? 7 : typeKey === 'hoodie' ? 6 : 0;

    return 0;
  };

  const collectColorMatrixState = (variantMatrix, typeKey, selectedSizeValue) => {
    const typeEntries = Array.isArray(variantMatrix)
      ? variantMatrix.filter((entry) => typeKeyFromValue(entry?.type) === typeKey)
      : [];
    const sizeEntries = selectedSizeValue
      ? typeEntries.filter((entry) => optionValueEquals(entry?.size, selectedSizeValue))
      : typeEntries;
    const colorState = new Map();

    sizeEntries.forEach((entry) => {
      const colorKey = colorKeyFromValue(entry?.color, typeKey);
      if (!colorKey) return;

      const rawValue = normalizeVariantValue(entry?.color);
      const existing =
        colorState.get(colorKey) || {
          rawValues: new Set(),
          availableRawValues: new Set(),
          hasAvailable: false,
        };

      existing.rawValues.add(rawValue);

      if (entry?.available) {
        existing.availableRawValues.add(rawValue);
        existing.hasAvailable = true;
      }

      colorState.set(colorKey, existing);
    });

    return colorState;
  };

  const collectSizeMatrixState = (variantMatrix, typeKey) => {
    const typeEntries = Array.isArray(variantMatrix)
      ? variantMatrix.filter((entry) => typeKeyFromValue(entry?.type) === typeKey)
      : [];
    const sizeState = new Map();

    typeEntries.forEach((entry) => {
      const sizeKey = normalizeVariantValue(entry?.size);
      if (!sizeKey) return;

      const existing =
        sizeState.get(sizeKey) || {
          hasAvailable: false,
        };

      if (entry?.available) {
        existing.hasAvailable = true;
      }

      sizeState.set(sizeKey, existing);
    });

    return sizeState;
  };

  const syncSizeButtons = (picker) => {
    const config = parseConfig(picker);
    const fieldset = picker.querySelector('[data-option-name="size"]');
    const typeInput = picker.querySelector('[data-option-name="type"] input:checked');

    if (!config || !fieldset || !typeInput) return;

    const typeKey = typeKeyFromValue(typeInput.value);
    const sizeState = collectSizeMatrixState(config.variantMatrix, typeKey);
    const matrixIsPartial = hasPartialVariantMatrix(config);
    const labels = Array.from(fieldset.querySelectorAll(':scope > .variant-option__button-label'));
    let checkedAvailable = false;
    let fallbackInput = null;

    labels.forEach((label) => {
      const input = label.querySelector('input');
      if (!(input instanceof HTMLInputElement)) return;

      const available = matrixIsPartial || Boolean(sizeState.get(normalizeVariantValue(input.value))?.hasAvailable);

      setLabelAvailability(label, available);
      setHiddenState(label, false);
      setDisplayState(label, '');

      if (!fallbackInput && available) {
        fallbackInput = input;
      }

      if (input.checked && available) {
        checkedAvailable = true;
      }
    });

    if (!checkedAvailable && fallbackInput) {
      applyInputSelection(fallbackInput, { activateMobilePreview: false });
    }
  };

  const syncClothingColors = (picker) => {
    const config = parseConfig(picker);
    const fieldset = picker.querySelector('[data-option-name="clothing-color"]');
    const typeInput = picker.querySelector('[data-option-name="type"] input:checked');
    const sizeInput = picker.querySelector('[data-option-name="size"] input:checked');

    if (!config || !fieldset || !typeInput) return;

    const typeKey = typeKeyFromValue(typeInput.value);
    const colorOrder = config.colorOrderByType?.[typeKey] || [];
    const references = config.colorReferences?.[typeKey] || {};
    const colorOrderIndex = new Map(colorOrder.map((key, index) => [key, index]));
    const labels = Array.from(fieldset.querySelectorAll(':scope > .variant-option__button-label'));
    const candidates = new Map();
    const previousCheckedInput = fieldset.querySelector('input:checked');
    const preferredColorKey = colorKeyFromValue(previousCheckedInput?.value, typeKey);
    const typeColorState = collectColorMatrixState(config.variantMatrix, typeKey, '');
    const scopedColorState = collectColorMatrixState(config.variantMatrix, typeKey, sizeInput?.value || '');
    const matrixIsPartial = hasPartialVariantMatrix(config);

    labels.forEach((label) => {
      const input = label.querySelector('input');
      const colorKey = colorKeyFromValue(input?.value, typeKey);
      const imageUrl = colorKey ? references[colorKey] : null;
      const typeState = colorKey ? typeColorState.get(colorKey) : null;
      const scopedState = colorKey ? scopedColorState.get(colorKey) : null;
      const normalizedRawValue = normalizeVariantValue(input?.value);
      const matchesType = typeState?.rawValues.has(normalizedRawValue);

      if (!input || !colorKey || !imageUrl || !colorOrderIndex.has(colorKey) || !matchesType) {
        setHiddenState(label, true);
        setDisplayState(label, 'none');
        return;
      }

      const current = candidates.get(colorKey);
      let score = prefixScore(input.value, typeKey);
      if (scopedState?.availableRawValues.has(normalizedRawValue)) score += 30;
      else if (scopedState?.rawValues.has(normalizedRawValue)) score += 20;
      else if (typeState?.availableRawValues.has(normalizedRawValue)) score += 10;
      if (input.checked) score += 10;
      if (!isLegacyTypePrefixedValue(input.value)) score += 4;

      const next = { label, input, imageUrl, score };

      if (!current || next.score > current.score) {
        candidates.set(colorKey, next);
      }
    });

    const visibleItems = [];

    colorOrder.forEach((colorKey, index) => {
      const candidate = candidates.get(colorKey);
      if (!candidate) return;

      upgradeLegacyColorButtonToSwatch(fieldset, candidate.label);
      updateSwatchImage(candidate.label, candidate.imageUrl, colorKey, typeKey);
      bindSwatchPreview(candidate.label);
      setLabelAvailability(candidate.label, matrixIsPartial || Boolean(scopedColorState.get(colorKey)?.hasAvailable));
      setHiddenState(candidate.label, false);
      setDisplayState(candidate.label, '');
      setStylePropertyIfChanged(candidate.label, '--dg-color-order', String(index));
      visibleItems.push(candidate);
    });

    labels.forEach((label) => {
      const input = label.querySelector('input');
      const colorKey = colorKeyFromValue(input?.value, typeKey);
      const selected = colorKey ? candidates.get(colorKey)?.label : null;

      if (selected !== label) {
        setHiddenState(label, true);
        setDisplayState(label, 'none');
      }
    });

    const orderedLabels = visibleItems.map(({ label }) => label);
    const currentLabels = labels.filter((label) => !label.hidden && label.style.display !== 'none');
    const orderChanged =
      currentLabels.length !== orderedLabels.length || currentLabels.some((label, index) => label !== orderedLabels[index]);

    if (orderChanged) {
      const fragment = document.createDocumentFragment();
      orderedLabels.forEach((label) => fragment.appendChild(label));
      fieldset.appendChild(fragment);
    }

    const swatchValue = fieldset.querySelector('.variant-option__swatch-value');
    if (swatchValue) {
      swatchValue.textContent = '';
      swatchValue.hidden = true;
    }

    const checkedInput = fieldset.querySelector('input:checked');
    const checkedLabel = checkedInput?.closest('.variant-option__button-label');
    const checkedVisible = checkedLabel && !checkedLabel.hidden && checkedLabel.style.display !== 'none';
    const checkedAvailable = checkedVisible && isOptionAvailable(checkedLabel);

    const preferredItem =
      (preferredColorKey && visibleItems.find(({ input }) => colorKeyFromValue(input?.value, typeKey) === preferredColorKey)) ||
      visibleItems.find(({ label }) => isOptionAvailable(label)) ||
      visibleItems[0];

    if ((!checkedVisible || !checkedAvailable) && preferredItem?.input) {
      applyInputSelection(preferredItem.input, { activateMobilePreview: false });
    }

    syncSelectedSwatchPreview(fieldset);
  };

  const syncTypeButtons = (picker) => {
    const fieldset = picker.querySelector('[data-option-name="type"]');

    if (!fieldset) return;

    fieldset.querySelectorAll(':scope > .variant-option__button-label').forEach((label) => {
      const input = label.querySelector('input');
      const text = label.querySelector('.variant-option__button-label__text');

      if (!input) return;

      const displayValue = readableTypeName(input.value);
      if (text && text.textContent !== displayValue) {
        text.textContent = displayValue;
      }

      if (input.getAttribute('aria-label') !== displayValue) {
        input.setAttribute('aria-label', displayValue);
      }
    });
  };

  const syncSizeCharts = (root) => {
    if (!root?.querySelector('[data-dg-size-chart]')) return;

    const typeKey = getCurrentTypeKey(root);
    const chartType = typeKey === 'tshirt' ? 'tee' : 'outerwear';

    root.dataset.dgPdpType = typeKey;

    root.querySelectorAll('[data-dg-size-chart] .size-table-group').forEach((table) => {
      table.hidden = table.dataset.sizeChartType !== chartType;
    });
  };

  const getCurrentVariantId = (root, picker) => {
    const formVariantId = root?.querySelector('product-form-component input[name="id"]')?.value;
    if (formVariantId) return String(formVariantId);

    const selectedVariantId = picker?.selectedVariant?.id;
    if (selectedVariantId) return String(selectedVariantId);

    const selectedInputVariantId = picker?.querySelector('input:checked')?.dataset?.variantId;
    if (selectedInputVariantId) return String(selectedInputVariantId);

    return '';
  };

  const syncPickerRequestUrl = (root, picker) => {
    if (!root || !picker) return;

    const currentUrl = new URL(window.location.href);
    const variantId = getCurrentVariantId(root, picker);

    currentUrl.hash = '';

    if (variantId) {
      currentUrl.searchParams.set('variant', variantId);
    } else {
      currentUrl.searchParams.delete('variant');
    }

    picker.dataset.productUrl = `${currentUrl.pathname}${currentUrl.search}`;
  };

  const getSelectedInputValue = (picker, optionName) =>
    picker?.querySelector(`[data-option-name="${optionName}"] input:checked`)?.value || '';

  const syncAll = () => {
    const roots = getProductInfoRoots();

    if (roots.length === 0) return;

    roots.forEach((root) => {
      const picker = getPickerForRoot(root);

      if (picker) {
        const nextState = {
          type: getSelectedInputValue(picker, 'type'),
          size: getSelectedInputValue(picker, 'size'),
          color: getSelectedInputValue(picker, 'clothing-color'),
          variantId: getCurrentVariantId(root, picker),
        };
        const previousState = picker.__dgSyncState || null;
        const isInitialSync = picker.dataset.dgSyncInitialized !== 'true';
        const typeChanged = isInitialSync || previousState?.type !== nextState.type;
        const sizeChanged = isInitialSync || previousState?.size !== nextState.size;
        const colorChanged = isInitialSync || previousState?.color !== nextState.color;
        const variantChanged = isInitialSync || previousState?.variantId !== nextState.variantId;

        if (variantChanged) {
          syncPickerRequestUrl(root, picker);
        }

        if (typeChanged) {
          syncTypeButtons(picker);
          syncSizeButtons(picker);
        }

        if (typeChanged || sizeChanged) {
          syncClothingColors(picker);
        } else if (colorChanged) {
          syncSelectedSwatchPreview(picker.querySelector('[data-option-name="clothing-color"]'));
        }

        picker.__dgSyncState = nextState;
        picker.dataset.dgSyncInitialized = 'true';
      }

      if (!picker || picker.dataset.dgLastTypeKey !== getCurrentTypeKey(root)) {
        syncSizeCharts(root);

        if (picker) {
          picker.dataset.dgLastTypeKey = getCurrentTypeKey(root);
        }
      }
    });
  };

  let syncQueued = false;

  const scheduleSync = () => {
    if (syncQueued) return;

    syncQueued = true;
    window.requestAnimationFrame(() => {
      syncQueued = false;
      syncAll();
    });
  };

  document.addEventListener('DOMContentLoaded', scheduleSync);
  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLElement)) return;
    if (!event.target.closest('variant-picker')) return;

    if (isTouchPreviewMode() && !event.target.closest('[data-option-name="clothing-color"]')) {
      clearTouchSwatchPreview(event.target.closest('variant-picker') || document);
    }
  });
  document.addEventListener(
    'pointerup',
    (event) => {
      const point = event.changedTouches?.[0] || event;
      const label =
        swatchLabelFromPoint(point.clientX, point.clientY) ||
        (event.target instanceof HTMLElement ? event.target.closest(SWATCH_LABEL_SELECTOR) : null);

      if (!label) return;

      event.preventDefault();
      selectSwatchLabel(label);
    },
    true
  );
  document.addEventListener('mousemove', (event) => {
    if (swatchLabelFromPoint(event.clientX, event.clientY)) return;

    hideSwatchPreview();
  });
  document.addEventListener('pointerdown', (event) => {
    if (!(event.target instanceof HTMLElement)) return;
    if (event.target.closest(SWATCH_LABEL_SELECTOR)) return;

    clearTouchSwatchPreview(document);
    hideSwatchPreview({ force: true });
  });
  document.addEventListener(
    'scroll',
    () => {
      hideSwatchPreview({ force: true });
    },
    { passive: true }
  );
  document.addEventListener('variant:update', scheduleSync);
  window.addEventListener('load', scheduleSync);

  [0, 150, 500, 1200, 2500, 4000].forEach((delay) => {
    window.setTimeout(scheduleSync, delay);
  });

  scheduleSync();
}
